// extracted by mini-css-extract-plugin
module.exports = {"chartPanel":"ChartPanel_chartPanel__2Z-AW","slide-in-right":"ChartPanel_slide-in-right__3eEm-","slide-out-right":"ChartPanel_slide-out-right__LZMK_"};